import { FC } from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';
import { PeriodEndReportFundOverviewDatapoints } from 'further-types/lp/period-end-report';
import Column from '../../../Pdf/components/Column';
import theme from '../../../Pdf/components/theme';
import FundOverviewDatapoint from './FundOverviewDatapoint';

const styles = StyleSheet.create({
  container: {
    width: '400px',
    paddingRight: theme.spacing(theme.spacingSizes.lg),
    borderWidth: 0.75,
    borderColor: theme.palette.grey[300],
    borderStyle: 'solid',
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
  },
  containerInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    width: '100%',
  },
  leftGutter: {
    width: theme.spacing(theme.spacingSizes.lg),
    backgroundColor: theme.palette.grey[50],
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
  },
  tableBody: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
});

type Props = {
  datapoints: PeriodEndReportFundOverviewDatapoints;
};

const PeriodEndReportDatapointsTable: FC<Props> = ({ datapoints }) => {
  return (
    <Column centered>
      <View style={styles.container}>
        <View style={styles.containerInner}>
          <View style={styles.leftGutter} />
          <View style={styles.tableBody}>
            {datapoints.map((datapoint, index) => (
              <FundOverviewDatapoint
                key={datapoint.label}
                datapoint={datapoint}
                index={index}
                totalCount={datapoints.length}
              />
            ))}
          </View>
        </View>
      </View>
    </Column>
  );
};

export default PeriodEndReportDatapointsTable;
